import { render, staticRenderFns } from "./BlockModel.vue?vue&type=template&id=550243b8&scoped=true&"
import script from "./BlockModel.vue?vue&type=script&lang=js&"
export * from "./BlockModel.vue?vue&type=script&lang=js&"
import style0 from "./BlockModel.vue?vue&type=style&index=0&id=550243b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550243b8",
  null
  
)

export default component.exports